import { Store } from 'libx';
import moment from 'moment';
import ApiError from 'shared/errors/ApiError';

import { MANAGER_EVENT } from 'shared/dictionaries/events';

export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const REQUEST_OPTIONS = {
  headers: {
    'Content-Type': 'application/json'
  }
}

//const DEFAULT_WIDGET_ORIGIN = document.referrer;

export default class ApiStore extends Store {

  domain = '';
  prefix = '';
  widgetOrigin = null;

  constructor() {
    super(...arguments);
    if (this.constructor === ApiStore)
      throw new Error('Api Store must not be instantiated on its own');

    window.addEventListener('message', ({ data: { name, details } = {} } = {}) => {
      if (name === MANAGER_EVENT.REGISTER_ORIGIN && details.origin && !this.widgetOrigin) {
        this.widgetOrigin = details.origin;
        this.rootStore.appStore.widgetOrigin = this.widgetOrigin;
      }
    });

    if (window.location.hostname === 'localhost') {
      this.widgetOrigin = 'http://localhost:3000/'
    }
  }

  configure({ domain, prefix }) {
    this.domain = domain;
    this.prefix = prefix;
  }

  buildUrl(type, { id, query, action } = {}) {

    let url = this.domain ? `${this.domain}/` : '/';
    if (this.prefix) url += `${this.prefix}/`;
    if (type) url += `${type}/`
    if (id) url += id;
    if (id && action) url += `/${action}`
    url += this.buildQuery(query);

    return url;
  }

  buildQuery(query = {}) {
    let queryParams = [];

    if (moment.isMoment(this.onDate)) {
      query.ondate = this.onDate.format(API_DATE_FORMAT);
    }

    Object.entries(query).forEach(([key, value]) => {
      queryParams.push(`${key}=${encodeURI(value)}`);
    });

    return `?${queryParams.join('&')}`;
  }

  async request(url, options = {}) {
    if (!url) throw new Error('URL must be provided for request');

    await this.waitForOrigin();

    const requestOptions = Object.assign({}, REQUEST_OPTIONS, options);
    
    Object.assign(requestOptions.headers, {
      'Api-Key': `${this.rootStore.appStore.apiKey}`,
      'Widget-Origin': this.widgetOrigin
    });

    let result = {};
    let response = null;
    const { appStore } = this.rootStore;

    try {
      appStore.clearApiErrors();
      response = await fetch(url, requestOptions);
    
      if(!response.ok)
      {
        if(response.status === 429)
        {
          var data = await response.json();
          var re = /in\s(\d+)\s/g;
          var res = re.exec(data.detail);
          if(res.length === 2)
          {
            throw new ApiError(response,Number(res[1]));
          }
        }
        throw new ApiError(response);
      }      
      result = response.json();
    } 
    catch (error) 
    {
      if (error instanceof ApiError) {
        appStore.showApiError(error);
      }
      else{
        appStore.showApiError(new ApiError(response));
      }
    }

    return result;
  }

  async waitForOrigin() {
    return new Promise((resolve) => {
      const waitPolling = window.setInterval(() => {
        if (this.widgetOrigin) {
          window.clearInterval(waitPolling);
          resolve();
        }
      }, 100);
    });
  }

}




// WEBPACK FOOTER //
// ./src/shared/stores/ApiStore.js